export function replaceHostname(input: string): string {
  return input.replace('%HOSTNAME%', `${window.location.protocol}//${window.location.hostname}`);
}
